import https from '@/utils/https';
import { IApi, IApiList } from '@/utils/api-types';
import {
  IAppointmentEmployeeItem,
  IStoreInfo,
  IUserInfoGetRes,
  IUserInfoUpdateReq,
  IUserLoginReq,
  IUserLoginRes,
  IUserLoginSmsReq,
} from '@/api/user-types';

// 用户登陆
export const apiUserLogin: IApi<IUserLoginRes, IUserLoginReq> = (params) =>
  https.post('/user/customer/customerLogin', params);

// 用户登录发送验证码
export const apiUserLoginSms: IApi<null, IUserLoginSmsReq> = (params) =>
  https.post('/user/customer/sendSmsVerificationCode', params);

// 用户信息查询
export const apiUserInfoGet: IApi<IUserInfoGetRes> = (params) =>
  https.post('/user/customer/getCustomerLogin', params);

// 用户信息修改
export const apiUserInfoUpdate: IApi<null, IUserInfoUpdateReq> = (params) =>
  https.post('/user/customer/updateCustomerSetting', params);

// 门店信息
export const apiStoreInfo: IApi<IStoreInfo, { id: number | string }> = (params) =>
  https.post('/shop/store/getById', params);

// 预约员工列表
export const apiAppointmentEmployeeList: IApiList<
  IAppointmentEmployeeItem,
  { storeId: number | string; appointmentDate: string; time: string; employeeName?: string }
> = (params) =>
  https.post('/user/appointment/query/employee', {
    pid: 1,
    curPage: 1,
    pageSize: 100,
    ...params,
  });
